(() => {
  const observed = new WeakSet();
  const resize = new ResizeObserver(entries => entries.forEach(({target}) => measure(target)));
  // Repeat the ribbon text until the track is at least twice the screen width,
  // so the -50% loop never leaves an empty gap (count stays even for a seamless loop).
  function fill(track) {
    const base = Array.from(track.children).filter(el => !el.hasAttribute('data-ribbon-clone'));
    if (!base.length) return;
    const need = (track.parentElement?.getBoundingClientRect().width || innerWidth) * 2 + 200;
    let guard = 0;
    while (track.scrollWidth < need && guard < 40) {
      base.forEach(el => { const c = el.cloneNode(true); c.setAttribute('data-ribbon-clone', ''); c.setAttribute('aria-hidden', 'true'); track.append(c); });
      guard++;
    }
    if (track.children.length % 2) { const c = base[0].cloneNode(true); c.setAttribute('data-ribbon-clone', ''); c.setAttribute('aria-hidden', 'true'); track.append(c); }
  }
  function measure(track) {
    fill(track);
    const speed = Number(getComputedStyle(document.documentElement).getPropertyValue('--ribbon-speed')) || 40;
    track.style.setProperty('--ribbon-duration', (track.getBoundingClientRect().width / 2 / speed) + 's');
  }
  function init() {
    document.querySelectorAll('.announcement__track,.marquee__track').forEach(track => {
      measure(track);
      if (!observed.has(track)) { resize.observe(track); observed.add(track); }
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-accordion] > button');
    if (!button) return;
    const open = button.parentElement.toggleAttribute('data-open');
    button.setAttribute('aria-expanded', String(open));
    const sign = button.querySelector('.faq-sign');
    if (sign) sign.textContent = open ? '−' : '+';
  });
  init();
  document.fonts.ready.then(init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', init, {passive:true});
})();
